import { IAPIRoutes } from "../../../../config";

export const RTBloggerRepositoryFactory = ({
  APIProvider,
  AuthService,
  APIRoutes,
}: {
  APIProvider: IAPIProvider;
  AuthService: IAuthService;
  APIRoutes: IAPIRoutes;
}) => {
  const { POST, GET, PUT, DELETE } = APIProvider;
  const { getAuthenticationToken } = AuthService;

  const postParseRTARAPI: IPostParseRTARAPI = async (payload) => {
    const formData = new FormData();
    formData.append("file", payload.file);

    return POST(
      APIRoutes.apiPostParseRTAR.replace(
        "{clinic_id}",
        payload.clinic_id.toString()
      ),
      formData,
      {
        Authorization: `Bearer ${await getAuthenticationToken()}`,
        "Content-Type": "multipart/form-data",
      }
    );
  };

  const getBillingSettingsAPI: IGetBillingSettingsAPI = async (payload) => {
    return GET(
      APIRoutes.apiGetBillingSettings.replace(
        "{clinic_id}",
        payload.clinic_id.toString()
      ),
      payload,
      {
        Authorization: `Bearer ${await getAuthenticationToken()}`,
      }
    );
  };

  const updateBillingSettingsAPI: IUpdateBillingSettingsAPI = async (
    payload
  ) => {
    return PUT(
      APIRoutes.apiUpdateBillingSettings.replace(
        "{clinic_id}",
        payload.clinic_id.toString()
      ),
      payload,
      {
        Authorization: `Bearer ${await getAuthenticationToken()}`,
      }
    );
  };

  const getServicesAPI: IGetServicesAPI = async (payload) => {
    return GET(APIRoutes.apiGetServices, payload, {
      Authorization: `Bearer ${await getAuthenticationToken()}`,
    });
  };

  const updateServicesAPI: IUpdateServicesAPI = async (payload) => {
    return POST(APIRoutes.apiUpdateServices, payload, {
      Authorization: `Bearer ${await getAuthenticationToken()}`,
    });
  };

  const getAuditAPI: IGetAuditAPI = async (payload) => {
    return GET(
      APIRoutes.apiGetAudit.replace(
        "{clinic_id}",
        payload.clinic_id.toString()
      ),
      payload,
      {
        Authorization: `Bearer ${await getAuthenticationToken()}`,
      }
    );
  };

  const updateAuditAPI: IUpdateAuditAPI = async (payload) => {
    return PUT(
      APIRoutes.apiUpdateAudit.replace(
        "{clinic_id}",
        payload.clinic_id.toString()
      ),
      payload,
      {
        Authorization: `Bearer ${await getAuthenticationToken()}`,
      }
    );
  };

  const postRTARBillingAPI: IPostRTARBillingAPI = async (payload) => {
    return POST(
      APIRoutes.apiPostRTARBilling
        .replace("{clinic_id}", payload.clinic_id.toString())
        .replace("{patient_id}", payload.patient_id.toString())
        .replace("{month}", payload.month.toString())
        .replace("{year}", payload.year.toString()),
      payload,
      {
        Authorization: `Bearer ${await getAuthenticationToken()}`,
      }
    );
  };

  const getCPTTypesAPI: IGetCPTTypesAPI = async () => {
    return GET(
      APIRoutes.apiGetCPTTypes,
      {},
      {
        Authorization: `Bearer ${await getAuthenticationToken()}`,
      }
    );
  };

  const getEnrolledPatientsAPI: IGetEnrolledPatientsAPI = async (payload) => {
    return GET(
      APIRoutes.apiGetEnrolledPatients.replace(
        "{clinic_id}",
        payload.clinic_id.toString()
      ),
      {},
      { Authorization: `Bearer ${await getAuthenticationToken()}` }
    );
  };

  const putBillingServiceStatusAPI: IPutBillingServiceStatusAPI = async (
    payload
  ) => {
    return PUT(
      APIRoutes.apiPutBillingServiceStatus
        .replace("{clinic_id}", payload.clinic_id.toString())
        .replace("{patient_id}", payload.patient_id.toString()),
      payload,
      {
        Authorization: `Bearer ${await getAuthenticationToken()}`,
      }
    );
  };

  const getOverviewPatientsAPI: IGetOverviewPatientsAPI = async (payload) => {
    return GET(
      APIRoutes.apiGetOverviewPatients
        .replace("{clinic_id}", payload.clinic_id.toString())
        .replace("{month}", payload.month.toString())
        .replace("{year}", payload.year.toString()),
      {},
      { Authorization: `Bearer ${await getAuthenticationToken()}` }
    );
  };

  const getBillingCycleAPI: IGetBillingCycleAPI = async (payload) => {
    return GET(
      APIRoutes.apiGetBillingCycle.replace(
        "{clinic_id}",
        payload.clinic_id.toString()
      ),
      {},
      { Authorization: `Bearer ${await getAuthenticationToken()}` }
    );
  };

  const getBillingCycleForPatientAPI: IGetBillingCycleForPatientAPI = async (
    payload
  ) => {
    return GET(
      APIRoutes.apiGetBillingCycleForPatient
        .replace("{clinic_id}", payload.clinic_id.toString())
        .replace("{patient_id}", payload.patient_id.toString())
        .replace("{month}", payload.month.toString())
        .replace("{year}", payload.year.toString()),
      {},
      { Authorization: `Bearer ${await getAuthenticationToken()}` }
    );
  };

  const deleteBillingCycleAPI: IDeleteBillingCycleAPI = async (payload) => {
    return DELETE(
      APIRoutes.apiDeleteBillingCycle
        .replace("{clinic_id}", payload.clinic_id.toString())
        .replace("{month}", payload.month.toString())
        .replace("{year}", payload.year.toString()) +
        `?current_status=${payload.current_status}`,
      {},
      { Authorization: `Bearer ${await getAuthenticationToken()}` }
    );
  };

  const putBillingCycleStatusForPatientAPI: IPutBillingCycleStatusForPatientAPI =
    async (payload) => {
      return PUT(
        `${APIRoutes.apiPutBillingCycleStatusForPatient
          .replace("{clinic_id}", payload.clinic_id.toString())
          .replace("{patient_id}", payload.patient_id.toString())
          .replace("{month}", payload.month.toString())
          .replace("{year}", payload.year.toString())}?new_status=${
          payload.new_status
        }`,
        {},
        { Authorization: `Bearer ${await getAuthenticationToken()}` }
      );
    };

  const deleteBillingCycleForPatientAPI: IDeleteBillingCycleForPatientAPI =
    async (payload) => {
      return DELETE(
        APIRoutes.apiDeleteBillingCycleForPatient
          .replace("{clinic_id}", payload.clinic_id.toString())
          .replace("{patient_id}", payload.patient_id.toString())
          .replace("{month}", payload.month.toString())
          .replace("{year}", payload.year.toString()),
        {},
        { Authorization: `Bearer ${await getAuthenticationToken()}` }
      );
    };

  const postBillingFilesAPI: IPostBillingFilesAPI = async (payload) => {
    return POST(
      APIRoutes.apiPostBillingFiles.replace(
        "{clinic_id}",
        payload.clinic_id.toString()
      ),
      payload,
      {
        Authorization: `Bearer ${await getAuthenticationToken()}`,
      }
    );
  };

  const putEnrollPatientAPI: IPutEnrollPatientAPI = async (payload) => {
    return PUT(
      APIRoutes.apiPutEnrollPatient.replace(
        "{admission_id}",
        payload.admission_id.toString()
      ),
      payload,
      { Authorization: `Bearer ${await getAuthenticationToken()}` }
    );
  };

  const postExtendEnrollPatientAPI: IPostExtendEnrollPatientAPI = async (
    payload
  ) => {
    return PUT(
      APIRoutes.apiPutExtendEnrollPatient.replace(
        "{rtx_enrolment_id}",
        payload.rtx_enrolment_id.toString()
      ),
      payload,
      { Authorization: `Bearer ${await getAuthenticationToken()}` }
    );
  };

  const getBillingReportsAPI: IGetBillingReportsAPI = async (payload) => {
    return GET(
      APIRoutes.apiGetBillingReports.replace(
        "{clinic_id}",
        payload.clinic_id.toString()
      ),
      {
        clinic_id: payload.clinic_id,
        calendar_months: payload.calendar_months,
      },
      { Authorization: `Bearer ${await getAuthenticationToken()}` }
    );
  };

  const updateBillingReportCollectedAmountAPI: IUpdateBillingReportCollectedAmountAPI =
    async (payload) => {
      return PUT(
        APIRoutes.apiUpdateBillingReportCollectedAmount
          .replace("{clinic_id}", payload.clinic_id.toString())
          .replace("{month}", payload.month.toString())
          .replace("{year}", payload.year.toString()),
        {
          collected_amount: payload.collected_amount,
        },
        { Authorization: `Bearer ${await getAuthenticationToken()}` }
      );
    };

  const getPreviouslyEnrolledPatientsAPI: IGetPreviouslyEnrolledPatientsAPI =
    async (payload) => {
      return GET(
        APIRoutes.apiGetPreviouslyEnrolledPatients.replace(
          "{clinic_id}",
          payload.clinic_id.toString()
        ),
        payload,
        { Authorization: `Bearer ${await getAuthenticationToken()}` }
      );
    };

  const postFixErrorAPI: IPostFixErrorAPI = async (payload) => {
    return POST(
      APIRoutes.apiPostFixError
        .replace("{clinic_id}", payload.clinic_id.toString())
        .replace("{patient_id}", payload.patient_id.toString()),
      payload,
      { Authorization: `Bearer ${await getAuthenticationToken()}` }
    );
  };

  return {
    postParseRTARAPI,
    getBillingSettingsAPI,
    updateBillingSettingsAPI,
    getServicesAPI,
    updateServicesAPI,
    getAuditAPI,
    updateAuditAPI,
    postRTARBillingAPI,
    getCPTTypesAPI,
    getEnrolledPatientsAPI,
    putBillingServiceStatusAPI,
    getOverviewPatientsAPI,
    getBillingCycleAPI,
    getBillingCycleForPatientAPI,
    deleteBillingCycleAPI,
    putBillingCycleStatusForPatientAPI,
    deleteBillingCycleForPatientAPI,
    postBillingFilesAPI,
    putEnrollPatientAPI,
    postExtendEnrollPatientAPI,
    getBillingReportsAPI,
    updateBillingReportCollectedAmountAPI,
    getPreviouslyEnrolledPatientsAPI,
    postFixErrorAPI,
  };
};
